var { Readability } = require('@mozilla/readability');
(function($) {
    'use strict';

    var article = '';
    var newArticle = '';
    var iframe = null;
    
    $( '.darklup-readmode-btn-inner' ).on( 'click', function() {

        $('body').addClass('darklup-readmode-body-overflow');

        if( !article && !newArticle  ) {

            var documentClone = document.cloneNode(true);

            article = new Readability(documentClone).parse();

            // Select the blog post container
            var postContent = document.querySelector('.darklup-reading-mode');
            
            if (postContent) {
                // Create a new document to wrap the extracted content
                var newDocument = document.implementation.createHTMLDocument();
                
                // Append the cloned post content to the new document's body
                newDocument.body.appendChild(postContent.cloneNode(true));

                // Use Readability on the new document
                newArticle = new Readability(newDocument).parse();

            }

        }

        
        // Create an iframe element
        iframe = document.createElement("iframe");

        // Set iframe attributes
        iframe.src = "http://darklup.wpc/"; // Replace with your URL
        iframe.frameBorder = "0"; // Optional: Remove border
        iframe.classList.add("darklup-readingmode-iframe"); // Add Class
        iframe.id ="darklup_readingmode_iframe"; // Add Class

        
        // Append iframe to the body
        document.body.appendChild(iframe);

        iframe.onload = function () {

            const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

            let title = article.title,
            siteName = frontendObject.site_name,
            regex = new RegExp(` – ${siteName}$`);

            title = title.replace(regex, "");

            // Write custom content inside the iframe
            iframeDoc.open();
            iframeDoc.write(`
                <html>
                <head></head>
                <body>
                <div class="darklup-readingmode-body-inner">
                <div class="darklup-readingmode-content"><h2>`+title+`</h2>`+newArticle.content+`</div>
                <div class="darklup-readingmode-tools">
                <ul>
                    <li id="darklup_readingmode_close"><span class="dashicons dashicons-no"></span></li>
                    <li id="fullscreenMode"><span class="dashicons dashicons-fullscreen-alt"></span></li>
                </ul>
                </div>
                </div>
                </body>
                </html>
            `);


            iframeDoc.close();

            // Create and append Dashicons CSS
            const dashicons = iframeDoc.createElement("link");
            dashicons.rel = "stylesheet";
            dashicons.href = window.location.origin + "/wp-includes/css/dashicons.min.css";
            iframeDoc.head.appendChild(dashicons);

            // Create and append Read Mode CSS from the plugin
            const readModeCSS = iframeDoc.createElement("link");
            readModeCSS.rel = "stylesheet";
            readModeCSS.href = window.location.origin + "/wp-content/plugins/darklup/assets/css/readmode.css";
            iframeDoc.head.appendChild(readModeCSS);

            
            //Create and append a JavaScript file
            const script = iframeDoc.createElement("script");
            script.src = window.location.origin + "/wp-content/plugins/darklup/assets/js/readmode-iframe.js"; // Example script URL

            iframeDoc.body.appendChild(script);
            

        }


        $('.darklup-readingmode-iframe').addClass('darklup-readmode-active');



    })





})(jQuery);
